import styled from 'styled-components';

const avatarSize = {
  xxs: '25px',
  xs: '40px',
  sm: '55px',
  md: '70px',
  lg: '85px',
  xl: '100px',
  xxl: '115px'
};

const StyledAvatar = styled.div`
  width: ${(props) => isNaN(props.size) ? avatarSize[props.size] : `${props.size}px`};
  height: ${(props) => isNaN(props.size) ? avatarSize[props.size] : `${props.size}px`};
  min-width: ${(props) => isNaN(props.size) ? avatarSize[props.size] : `${props.size}px`};
  min-height: ${(props) => isNaN(props.size) ? avatarSize[props.size] : `${props.size}px`};
  border-radius: 50%;
  background-size: cover;
  background-image: url(${(props) => props.src});
  box-shadow: ${(props) => props.shadow && props.theme.shadows.depth1};
`;

export const Avatar = StyledAvatar;